import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1v4XRTb9eEQ19HMYezNlZMwycOowvdWY",
  authDomain: "tibiawallstreet.firebaseapp.com",
  projectId: "tibiawallstreet",
  storageBucket: "tibiawallstreet.appspot.com",
  messagingSenderId: "1051169348853",
  appId: "1:1051169348853:web:2a4145b05929f0fa5df9bc",
  measurementId: "G-9BLBPPLCQP"
};


Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
